export const APP_VERSION = "0.1.12";

export const CHANGELOG = [
  {
    version: "0.1.12",
    date: "05/08/2026",
    added: [
      "Mode Organiser (bouton ⇅ en haut à droite du panneau Scènes & Plans) pour réorganiser scènes et plans sans passer par le Shot Editor.",
      "Organisation des plans : sélection multiple (coche), suppression groupée et déplacement d'un ou plusieurs plans dans une scène précise (clic sur la scène cible puis bouton ➜).",
      "Organisation des scènes : renommage, sélection multiple (coche), déplacement (flèches monter / descendre) et suppression (la scène est barrée et ses plans masqués de la shotlist, de façon réversible).",
      "Renommage de scène répercuté dans le scénario : la ligne d'en-tête est réécrite, en conservant le numéro de scène et un éventuel numéro Fountain.",
      "Réglage « Déplacement des scènes » : choisir de déplacer réellement le bloc de texte dans le scénario (par défaut) ou de réordonner uniquement l'affichage.",
      "Éditeur des champs de plan : possibilité de masquer un tag (icône œil) pour qu'il n'apparaisse plus dans la liste des plans.",
      "Confirmation avant la suppression de plans ou de scènes en mode Organiser.",
    ],
    improved: [
      "Import du découpage CSV (Menu > Importer) désactivé tant qu'aucun scénario n'est chargé.",
      "Champ de numéro de plan (« Shot # ») retiré du Shot Editor : l'ordre des plans se change via les boutons monter / descendre ou le glisser-déposer.",
    ],
    fixed: [
    ],
  },
  {
    version: "0.1.11",
    date: "04/08/2026",
    added: [
      "Format d'écran « Golden Ratio : 1.618:1 » dans les réglages.",
      "Export du scénario en l'état au format .txt ou .fountain (Menu > Exporter).",
      "Raccourci clavier Ctrl/Cmd + S pour sauvegarder le projet.",
      "Bouton Sauvegarder déplacé en haut à droite : il devient violet quand le projet a été modifié depuis la dernière sauvegarde.",
      "Bouton À propos déplacé en haut à droite (à gauche du numéro de version).",
      "Avertissement avant la fermeture de l'onglet lorsqu'un projet contient du contenu.",
      "Import CSV : case à cocher par scène pour inclure ou exclure une scène du CSV de l'import.",
      "Éditeur de scène (bouton ⋮ sur chaque scène) : ratio d'écran et format couleur (Couleurs / Monochrome / Noir et blanc) appliqués à tous les plans de la scène.",
      "Format cadre et format couleur réglables aussi individuellement par plan dans le Shot Editor (override, hérite de la scène par défaut).",
      "Tags « Ratio » et « Format couleur » sur les plans (réordonnables dans l'éditeur de champs) et colonnes correspondantes dans les exports PDF / Excel / CSV / HTML.",
    ],
    improved: [
      "Import CSV : table de correspondance des scènes (chaque valeur du CSV est associée explicitement à une scène de l'app, avec pré-remplissage automatique) — les plans ne tombent plus tous dans la première scène.",
      "Les exports (PDF, Excel, CSV, HTML) respectent désormais l'ordre d'affichage des plans de la shotlist.",
      "À propos : précision que les scénarios, projets et images ne sont jamais conservés en ligne + séparateurs adaptatifs à la taille de la fenêtre.",
      "Réorganisation de la barre du haut (Sauvegarder, À propos, Version) et numéro de plan retiré du Shot Editor.",
      "Export du scénario (.txt / .fountain) regroupé dans une sous-section « Scénario » repliable.",
    ],
    fixed: [
    ],
  },
  {
    version: "0.1.10",
    date: "29/07/2026",
    added: [
      "Bouton MASTER dans le Shot Editor pour marquer une prise master (badge sur le plan, affiché dans l'export PDF en bas à droite du plan et dans tous les autres exports).",
      "Importateur de découpage CSV (Menu > Importer > Importer découpage) avec association manuelle des colonnes du CSV aux champs de Shotlist.",
      "Bouton pour replier / faire réapparaître le panneau Scénario.",
      "Bouton « Ajouter Plan sans texte » (menu déroulant du bouton Ajouter Plan) pour créer un insert sans sélection de texte.",
      "Changement manuel du numéro d'un plan : les autres plans de la scène se resynchronisent automatiquement.",
      "Bouton « Supprimer texte assigné » à côté de « Supprimer Plan ».",
      "Import / modification de l'image d'un plan directement depuis le Shot Editor (fonctionne aussi en vue compacte).",
      "Échelles de plan « Plan rapproché » et « Plan moyen ».",
      "Barre de progression lors de l'export PDF (panneau d'attente qui se ferme automatiquement).",
      "Export PDF : réglage global pour masquer les sections vides, + pages optionnelles de Couverture et de Crédits.",
      "Déploiement du Shot Editor également au double-clic sur un plan.",
      "Réordonnancement des plans dans la liste par glisser-déposer ou boutons monter / descendre (renumérotation automatique, avec confirmation pour les plans master ou liés).",
      "Bouton pour afficher le Shot Editor à la place du panneau Scénario.",
    ],
    improved: [
      "Les numéros de séquence du scénario sont désormais conservés et affichés partout au lieu d'une renumérotation en 1, 2, 3.",
      "Simplification des libellés de mouvement (ex. « Plan fixe » → « Fixe ») et « Suivi de plan » → « Suivi de trépied ».",
      "L'application tient dans des plus petites résolutions sans barres de défilement horizontales / verticales.",
      "Intégration des images dans l'export PDF plus robuste (ré-encodage automatique des formats non pris en charge directement).",
      "Le tag « Master » apparaît désormais en premier dans les tags du plan.",
      "À propos : mention du logiciel gratuit à citer au générique de fin et de l'aide de ChatGPT et Claude.",
    ],
    fixed: [
      "Éditeur de scénario : Le curseur ne se téléporte plus à chaque frappe lorsqu'un plan est sélectionné.",
    ],
  },
  {
    version: "0.1.9",
    date: "06/05/2026",
    added: [
      "Ajout fonctionnalité de choix du format cinéma des cadres de Shot dans les réglages principaux"
    ],
    improved: [
      
    ],
    fixed: [
      "Correction d'export Excel/Sheets et ZIP qui ne fonctionnait pas",
      "Correction dans l'export PDF lors d'un nom de scène trop long cela dépassait du cadre, maintenant le nom de scène est réduit pour tenir dans le cadre."
    ],
  },
  {
    version: "0.1.8",
    date: "02/02/2026",
    added: [
      "Ajout du système de mise en valeur graphique et de la position des champs et tags entre les plans et le Shot Editor - Bouton à coté du bouton Liste classique"
    ],
    improved: [
      "Amélioration du système de rafraichissement du scénario en supprimant un plan d'un texte supprimé après rafraichissement"
    ],
    fixed: [
      "Correction des termes d'échelle qui étaient dupliqués et remplaçaient tous ceux des champs du Shot Editor."
    ],
  },
  {
    version: "0.1.7",
    date: "29/01/2026",
    added: [
      "Choix du préfix de plan dans les Réglages (P1, SH1 ou juste le numéro de plan)",
      "Choix des termes anglais - français pour les champs du Shot Editor"
    ],
    improved: [],
    fixed: [
    ],
  },
  {
    version: "0.1.6",
    date: "29/01/2026",
    added: [
      "En cliquant sur un plan de la liste cela téléporte la vue au bloc corréspondant dans le scénario en Vue Scène"
    ],
    fixed: [
      "Restructuration des tailles des modales export PDF, à propos, réglages, rafraichissement scénario et mises à jour",
      "Unification des boutons ✕ des modales"
    ],
  },
  {
    version: "0.1.5",
    date: "22/01/2026",
    added: [
      "Ajout de la fonction de journal de mise à jour",
    ],
    improved: [
      "Panneau Shot Editor fixé dans l'affichage.",
      "Déplacement du bouton burger menu à coté du logo.",
      "Amélioration graphique des sliders de scroll.",
    ],
  },
  {
    version: "0.1.4",
    date: "21/01/2026",
    added: [
      "Ajout de système de mise à jour du fichier scénario / Bouton mise à jour -> bouton remplacement fichier et bouton actualisation manuelle post écriture dans l'éditeur de texte interne. (Bouton à coté du bouton lock - Uniquement disponible en mode vue scénario)",
    ],
    fixed: [
      "Bouton export PDF non fonctionnel dans la modal débuggé.",
    ],
  },
  {
    version: "0.1.3",
    date: "20/01/2026",
    added: [
      "Bouton 'Lock' - bloquer/débloquer édition du scénario (Uniquement disponible en mode vue scénario", 
      "Ajouté dans le panneau du scènario en haut à coté du bouton switch de vue)",
      "Lors d'un click sur un bloc de plan dans le scénario dans la vue scène, cela téléporte le slider sur le plan correspondant dans la liste de plan.",
      "Bouton 'Reset' - Permet de rénitialiser les données d'un plan (Ajouté dans le panneau Shot Editor)",
    ],
  },
  {
    version: "0.1.2",
    date: "14/01/2026",
    added: [
      "Ajout bouton coche dans les préférences pour choisir de compter les plans liés dans les totaux. -    Si désactivé, les plans liés ne sont pas comptabilisés dans les différents totaux mais uniquement leurs plans d'origines.",
    ],
  },
  {
    version: "0.1.1",
    date: "14/01/2026",
    added: [
      "Système de plan lié (Permet de lier un plan avec un autre copiant ainsi sa couleur, toutes ses données et changeant la nomenclature pour numéro + lettre)",
    ],
    improved: [
      "Meilleur affichage du panneau récapitulatif.",
    ],
  },
  {
    version: "0.1.0",
    date: "13/01/2026",
    added: [
      "Alpha Release.",
    ]
  },
];

// Compat : si ailleurs tu importes default, ça continue de marcher
export default APP_VERSION;